module.exports = __webpack_public_path__ + "img/antes_despues_186.6934b4af.png";